import { apiClient } from './client';
export const oneDriveAuthApi = {
    /** Get the OAuth authorization URL to open in popup */
    initiate: async () => {
        return apiClient.get('/api/Auth/OneDrive/Initiate');
    },
    /** Check if user has connected their OneDrive account */
    getStatus: async () => {
        return apiClient.get('/api/Auth/OneDrive/Status');
    },
    /** Get a fresh access token for the OneDrive file picker */
    getPickerToken: async () => {
        return apiClient.get('/api/Auth/OneDrive/PickerToken');
    },
    /** Disconnect the user's OneDrive account */
    disconnect: async () => {
        return apiClient.delete('/api/Auth/OneDrive/Disconnect');
    },
};
